import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { PageHeader } from '@/components/shared/PageHeader';
import { UserTable } from '@/components/features/users/UserTable';
import { UserDialog } from '@/components/features/users/UserDialog';
import { WalletAdjustmentDialog } from '@/components/features/users/WalletAdjustmentDialog';
import { UserFilters } from '@/components/features/users/UserFilters';
import { DataTablePagination } from '@/components/shared/DataTablePagination';
import { useUsers } from '@/lib/hooks';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { ROUTES } from '@/config/routes';
import type { UserFilters as UserFiltersType, User } from '@/lib/types';

export const Route = createFileRoute('/_auth/_admin/admin/users/')({
  component: UsersComponent,
});

function UsersComponent() {
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [walletUser, setWalletUser] = useState<User | null>(null);
  const [walletOpen, setWalletOpen] = useState(false);
  const [filters, setFilters] = useState<UserFiltersType>({});
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);

  const { data, isLoading } = useUsers({
    ...filters,
    page,
    per_page: perPage,
  });

  const handleRowClick = (user: User) => {
    navigate({ to: ROUTES.ADMIN.USER_DETAIL(user.id) });
  };

  const handleWalletClick = (user: User) => {
    setWalletUser(user);
    setWalletOpen(true);
  };

  return (
    <div className="space-y-6">
      <PageHeader
        title="Пользователи"
        action={
          <Button onClick={() => setDialogOpen(true)}>
            <Plus className="mr-2 h-4 w-4" />
            Добавить пользователя
          </Button>
        }
      />

      <UserFilters filters={filters} onFiltersChange={(newFilters) => setFilters(newFilters as UserFiltersType)} />

      <UserTable
        data={data?.data || []}
        isLoading={isLoading}
        onRowClick={handleRowClick}
        onWalletClick={handleWalletClick}
      />

      {data?.meta && (
        <DataTablePagination
          meta={data.meta}
          onPageChange={setPage}
          onPerPageChange={setPerPage}
        />
      )}

      <UserDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        mode="create"
      />

      <WalletAdjustmentDialog
        open={walletOpen}
        onOpenChange={setWalletOpen}
        user={walletUser}
      />
    </div>
  );
}
